<template>
    <v-row>
        <v-col cols="5">
            <span align="left" class="text-body-2 font-weight-medium">
                {{ this.label }}
            </span>
        </v-col>
        <v-col>
            <v-btn-toggle
            v-model="toggle"
            mandatory
            dense
            active-class="primary white--text"
            class="white"
            >
                <v-btn :value="true" :disabled="this.disabled">
                    {{ this.textTrue }}
                </v-btn>
                <v-btn :value="false" :disabled="this.disabled">
                    {{ this.textFalse }}
                </v-btn>
            </v-btn-toggle>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'ToggleSwitch',
    model: {
        prop: 'value'
    },
    props:{
        value: {
            type: Boolean,
            default: false
        },
        textTrue:{
            type:String,
            default:'ON'
        },
        textFalse:{
            type:String,
            default:'OFF'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            default: 'switch'
        }
    },
    computed: {
        toggle: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>